// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3d1kJ","type":"styles_type__883TN","choices":"styles_choices__2ZyB9"};